import { type InputElementBase, type InputElementBaseProperties } from "@episerver/forms-sdk";
import { useEffect, useMemo } from "react";
import ElementWrapper from "./shared/ElementWrapper";
import { useElement } from "../../hooks/useElement";
import { ValidationMessage } from "./shared";
import Icon from "2-core-elements/Icon/Icon";
import { useForms } from "3-components/OptimizelyForm/context/store";
import { DispatchFunctions } from "3-components/OptimizelyForm/context/dispatchFunctions";

interface LinkToggleProps extends InputElementBaseProperties {
    disabledText: string;
    enabledText: string;
}

interface LinkToggle extends InputElementBase {
    properties: LinkToggleProps;
}

export interface LinkToggleElementBlockProps {
    element: LinkToggle
}

export const LinkToggleElementBlock = (props: LinkToggleElementBlockProps) => {
    const { element } = props;
    const { elementContext, handleChange, handleBlur} = useElement(element);
    const { isVisible, validationResults, value, validatorClasses, extraAttr} = elementContext;
    const {properties: {enabledText, disabledText}} = element;
    const formContext = useForms();
    const dispatchFuncs = new DispatchFunctions();

    useEffect(() => {
        // look for any auto lookup address field on the form
        const isAddressFieldExists = (formContext?.formContainer.formElements || []).filter(el => el.contentType === 'AddressElementBlock');

        const isDisabled = value === 'yes';

        if( isAddressFieldExists.length ) {
            const addressElements = formContext?.formContainer.formElements.filter(el => el.contentType === 'AddressElementBlock');
            
            addressElements?.forEach((field) => {
                const name = field.key;
                const inputField = document.querySelector(`input[name="${name}_lookup"]`) as HTMLInputElement;

                if( value === 'yes' ) {
                    // disable & reset validation for address field
                    inputField.disabled = isDisabled;
                    dispatchFuncs.updateValue(name, '-');
                    dispatchFuncs.updateValidation(name, {
                        valid: true,
                        message: ''
                    });
                    inputField.classList.add('fake-validation-input');
                } else {
                    inputField.disabled = isDisabled;
                    dispatchFuncs.updateValue(name, '');
                    inputField.classList.remove('fake-validation-input');
                }
            })
        }
    }, [value])

    return useMemo(()=>(
        <ElementWrapper className={`FormChoice ${validatorClasses}`} validationResults={validationResults} isVisible={isVisible} extraAttr={extraAttr}>
            <div className="FormCustom__Input LinkToggle__Input--wrapper">
                <label htmlFor={element.key}>
                    <input type="checkbox" 
                        id={element.key}
                        name={element.key} 
                        value={value}
                        checked={value === 'yes'}
                        disabled={value === 'yes'}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        data-custom-element="link-toggle"/>
                    
                    <div className="LinkToggle__Label-wrapper">
                        <div className="LinkToggle__Label-text">{value === 'yes' ? enabledText : disabledText}</div>
                        <div className="LinkToggle__Icon-box">
                            <Icon icon="chevron-down" />
                        </div>
                    </div>
                </label>
                
            </div>

            <ValidationMessage element={element} validationResults={validationResults} />
        </ElementWrapper>
    ),[isVisible, validationResults, value]);
}